import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPost, doPut } from 'api/request';
import type {
  SmsTemplate,
  SmsTemplateRequest,
} from 'api/resources/smsTemplates/types';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';

const VERSION = 'v2';

export const getSmsTemplates = (accountId: string, projectId: string) => {
  return doGet<SmsTemplate[]>(
    generateNextPath(ENDPOINTS.SMS_TEMPLATES, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    { version: VERSION },
  );
};

export const createSmsTemplate = ({
  accountId,
  projectId,
  request,
}: {
  accountId: string;
  projectId: string;
  request: SmsTemplateRequest;
}) => {
  return doPost<SmsTemplate>(
    generateNextPath(ENDPOINTS.SMS_TEMPLATES, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    request,
    { version: VERSION },
  );
};

export const editSmsTemplate = ({
  accountId,
  projectId,
  request,
  smsTemplateId,
}: {
  accountId: string;
  projectId: string;
  request: SmsTemplateRequest;
  smsTemplateId: string;
}) => {
  return doPut<SmsTemplate>(
    generateNextPath(ENDPOINTS.SMS_TEMPLATE, {
      accountId,
      projectId,
      smsTemplateId,
    }),
    LOGGER_TYPE.JUPITER,
    request,
    { version: VERSION },
  );
};

export const deleteSmsTemplate = ({
  accountId,
  projectId,
  smsTemplateId,
}: {
  accountId: string;
  projectId: string;
  smsTemplateId: string;
}) => {
  return doDelete(
    generateNextPath(ENDPOINTS.SMS_TEMPLATE, {
      accountId,
      projectId,
      smsTemplateId,
    }),
    LOGGER_TYPE.JUPITER,
    undefined,
    { version: VERSION },
  );
};
